import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: authRoles.admin,
    routes: [
        {
            path: '/split-producers',
            component: FuseLoadable({
                loader: () => import('./SplitProducerApp'),
            }),
        },
    ],
};

export default [Index];
